/**
 * Created by Ray on 2017/9/18.
 */

import { Component } from '@angular/core';
import {LookupService} from '../shared/service/lookupService';

@Component({
    selector: 'svc-footer',
    templateUrl: './footer.component.html'
})
export class Footer {

    refreshDate;

    constructor(private lookupService: LookupService) {
        this.lookupService.getRefreshDate(item => {
            this.refreshDate = item;
        });
    }

    getYear() {
        return new Date().getFullYear();
    }
}



// WEBPACK FOOTER //
// C:/Projects/ServiceChain/servicechain2/svc-ui/TRUNK/src/app/footer/footer.component.ts